<div *ngIf="component?.data$ | async as componentData">
  <div class="puff-with-links-collection-holder row no-gutters">
    <ng-container *ngFor="let uid of componentData.components?.split(' ')">
      <div
        class="col-12"
        [cxComponentWrapper]="{
          flexType: 'PuffWithLinksComponent',
          typeCode: 'PuffWithLinksComponent',
          uid: uid
        }"
      ></div>
    </ng-container>
  </div>
</div>
